
import { Component, Vue } from 'vue-property-decorator'
@Component({
})
export default class kfGuide extends Vue {

  toDownwindows() {
    window.open("https://ptyyzx-xass.oss-cn-beijing.aliyuncs.com/mgtv_oa/cs/%E5%B0%8F%E8%8A%92%E5%AE%A2%E6%9C%8D.exe")
  }
  toDownMac() {
    window.open("https://ptyyzx-xass.oss-cn-beijing.aliyuncs.com/mgtv_oa/cs/%E5%B0%8F%E8%8A%92%E5%AE%A2%E6%9C%8D.dmg")
  }
  toGuidePdf() {
     window.open("https://xiaomang.mgtv.com/help?article=121")
  }
}
